module.exports = __webpack_public_path__ + "static/media/10-3.b982e054.mp3";